<template>
    <export-list />
</template>

<script>
import ExportOverzichtList from '../components/ExportOverzichtList.vue'

export default {
  components: {
    ExportList: ExportOverzichtList
  },
  name: 'ExportListView'
}
</script>
